import * as yup from 'yup';
import { error } from '../../validation/text';

export const materialSchema = yup.object().shape({
  name: yup.string().required(error.required).max(250, error.below250),
  category: yup.number().min(1, error.requiredSelect).required(error.required),
  co2Default: yup
    .number()
    .typeError(error.number)
    .required(error.required)
    .max(99999, error.below100000)
    .test('is-decimal-3-places', error.decimal3, (value) => {
      if (value >= 100) {
        return Number.isInteger(value);
      } else {
        return /^[0-9]+(\.[0-9]{1,3})?$/.test(value.toString());
      }
    }),
  co2Unit: yup.string().required(error.required).max(250, error.below250),
  costUnit: yup.string().nullable().max(250, error.below250),
  co2Standard: yup.string().nullable().max(250, error.below250),
  priceCondition: yup.string().nullable().max(250, error.below250),
  note: yup.string().nullable().max(250, error.below250),
  sort: yup
    .number()
    .typeError(error.number)
    .required(error.required)
    .max(99999, error.below100000)
    .test('is-decimal-1-place', error.decimal1, (value) => {
      return /^[0-9]+(\.[0-9]{1})?$/.test(value.toString());
    }),
  showMessage: yup.array().of(yup.boolean().required()).required(error.required)
});
